import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const EgitimlerimPage = () => {
  const [egitimler, setEgitimler] = useState([]);
  const [seciliEgitim, setSeciliEgitim] = useState(null);
  const [sertifika, setSertifika] = useState(null);
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const dosyaRef = useRef(null);

  const yukle = async () => {
    try { const res = await axios.get('/api/egitim/benim/liste'); setEgitimler(res.data); }
    catch(err) { console.error(err); }
  };

  useEffect(() => { yukle(); }, []);

  const handleTamamla = async (atamaId) => {
    setYukleniyor(true); setSonuc(null);
    try {
      const formData = new FormData();
      if (sertifika) formData.append('sertifika', sertifika);
      await axios.post('/api/egitim/atama/' + atamaId + '/tamamla', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      setSonuc({ tip: 'basari', mesaj: 'Egitim tamamlandi! Sertifika yuklendi.' });
      setSertifika(null);
      const res = await axios.get('/api/egitim/benim/liste');
      setEgitimler(res.data);
      const guncellenmis = res.data.find(e => e.id === atamaId);
      if (guncellenmis) setSeciliEgitim(guncellenmis);
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const fmt = t => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

  const durumInfo = (durum, bitis) => {
    if (durum === 'tamamlandi') return { badge: <span className="badge badge-tamamlandi">Tamamlandi</span>, renk: 'var(--yesil)', bg: 'var(--yesil-acik)', ikon: '✅' };
    if (bitis && new Date(bitis) < new Date()) return { badge: <span className="badge badge-hata">Suresi Gecti</span>, renk: 'var(--kirmizi)', bg: 'var(--kirmizi-acik)', ikon: '⚠️' };
    return { badge: <span className="badge badge-bekliyor">Devam Ediyor</span>, renk: 'var(--mavi)', bg: 'var(--mavi-acik)', ikon: '📖' };
  };

  const istatistikler = {
    toplam: egitimler.length,
    tamamlanan: egitimler.filter(e => e.durum === 'tamamlandi').length,
    devam: egitimler.filter(e => e.durum !== 'tamamlandi').length,
    sertifika: egitimler.filter(e => e.sertifika_adi).length,
  };

  // DETAY SAYFASI
  if (seciliEgitim) {
    const info = durumInfo(seciliEgitim.durum, seciliEgitim.bitis_tarihi);
    const bitisYaklasiyor = seciliEgitim.bitis_tarihi && seciliEgitim.durum !== 'tamamlandi' && new Date(seciliEgitim.bitis_tarihi) > new Date() && (new Date(seciliEgitim.bitis_tarihi) - new Date()) < 7 * 24 * 60 * 60 * 1000;

    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '1.5rem' }}>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setSeciliEgitim(null); setSonuc(null); setSertifika(null); }}>← Geri</button>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px', flexWrap: 'wrap' }}>
              <h2 style={{ fontSize: '22px' }}>{seciliEgitim.ad}</h2>
              {info.badge}
            </div>
            {seciliEgitim.aciklama && <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{seciliEgitim.aciklama}</p>}
          </div>
        </div>

        {bitisYaklasiyor && (
          <div className="alert alert-error" style={{ marginBottom: '1rem' }}>
            ⚠️ Bu egitimin bitis tarihi yaklasıyor: {fmt(seciliEgitim.bitis_tarihi)}
          </div>
        )}
        {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

        {/* Durum banner */}
        <div style={{ background: info.bg, border: '1px solid ' + info.renk + '33', borderRadius: 'var(--radius)', padding: '1.25rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <span style={{ fontSize: '32px' }}>{info.ikon}</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: '600', color: info.renk, marginBottom: '4px' }}>
              {seciliEgitim.durum === 'tamamlandi' ? 'Bu egitimi tamamladınız!' : seciliEgitim.bitis_tarihi && new Date(seciliEgitim.bitis_tarihi) < new Date() ? 'Bu egitimin suresi doldu.' : 'Egitim devam ediyor.'}
            </div>
            <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
              <span>Atanma: {fmt(seciliEgitim.atama_tarihi)}</span>
              {seciliEgitim.bitis_tarihi && <span>Bitis: {fmt(seciliEgitim.bitis_tarihi)}</span>}
              {seciliEgitim.tamamlanma_tarihi && <span style={{ color: 'var(--yesil)' }}>Tamamlandi: {fmt(seciliEgitim.tamamlanma_tarihi)}</span>}
            </div>
          </div>
          {seciliEgitim.platform_link && (
            <a href={seciliEgitim.platform_link} target="_blank" rel="noreferrer" className="btn btn-primary" style={{ whiteSpace: 'nowrap' }}>
              Egitime Git →
            </a>
          )}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
          {/* Egitim Bilgileri */}
          <div className="card">
            <div style={{ marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <h3 style={{ fontSize: '15px', fontWeight: '600' }}>Egitim Detaylari</h3>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {[
                { label: 'EGITIM ADI', value: seciliEgitim.ad },
                { label: 'ACIKLAMA', value: seciliEgitim.aciklama },
                { label: 'ATANMA TARIHI', value: fmt(seciliEgitim.atama_tarihi) },
                { label: 'BITIS TARIHI', value: seciliEgitim.bitis_tarihi ? fmt(seciliEgitim.bitis_tarihi) : 'Suresiz' },
                seciliEgitim.tamamlanma_tarihi && { label: 'TAMAMLANMA', value: fmt(seciliEgitim.tamamlanma_tarihi), renk: 'var(--yesil)' },
              ].filter(Boolean).map((item, i) => item.value && (
                <div key={i}>
                  <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '3px' }}>{item.label}</div>
                  <div style={{ fontSize: '14px', fontWeight: '500', color: item.renk || 'var(--yazi)' }}>{item.value}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Sertifika */}
          <div className="card">
            <div style={{ marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <h3 style={{ fontSize: '15px', fontWeight: '600' }}>Sertifika</h3>
            </div>

            {seciliEgitim.sertifika_adi ? (
              <div>
                <div style={{ padding: '1.25rem', background: 'var(--yesil-acik)', borderRadius: 'var(--radius-sm)', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ fontSize: '28px' }}>🏆</span>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: 'var(--yesil)', marginBottom: '2px' }}>Sertifika Yuklendi</div>
                    <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{seciliEgitim.sertifika_adi}</div>
                  </div>
                </div>
                <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', lineHeight: '1.5' }}>
                  ✓ Sertifikaniz sisteme kaydedildi.<br/>
                  ✓ Personel kartınızda goruntülenebilir.
                </div>
              </div>
            ) : seciliEgitim.durum === 'tamamlandi' ? (
              <div style={{ textAlign: 'center', padding: '1.5rem', color: 'var(--yazi-ikincil)' }}>
                <div style={{ fontSize: '32px', marginBottom: '8px' }}>📋</div>
                <div style={{ fontSize: '13px' }}>Egitim tamamlandi ancak sertifika yuklenmedi.</div>
              </div>
            ) : (
              <div>
                <div style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '1rem', marginBottom: '1rem', fontSize: '13px', color: 'var(--yazi-ikincil)', lineHeight: '1.6' }}>
                  📌 Egitimi tamamladıktan sonra sertifikanızı buraya yukleyebilirsiniz. Sertifika yuklediginizde egitim tamamlandi olarak isaretilenecektir.
                </div>
                <input type="file" ref={dosyaRef} accept=".pdf,.jpg,.jpeg,.png" style={{ display: 'none' }} onChange={e => setSertifika(e.target.files[0])} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <button type="button" className="btn btn-secondary" onClick={() => dosyaRef.current?.click()}
                    style={{ justifyContent: 'flex-start', gap: '8px' }}>
                    <span>📄</span> {sertifika ? sertifika.name : 'Sertifika Sec (PDF, JPG, PNG)'}
                  </button>
                  {sertifika && (
                    <div style={{ fontSize: '12px', color: 'var(--yesil)', padding: '4px 8px', background: 'var(--yesil-acik)', borderRadius: 'var(--radius-sm)' }}>
                      ✓ {sertifika.name} secildi
                    </div>
                  )}
                  <button type="button" className="btn btn-primary" onClick={() => handleTamamla(seciliEgitim.id)} disabled={yukleniyor}>
                    {yukleniyor ? 'Kaydediliyor...' : '✅ Tamamlandi Olarak Isaretle'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // LİSTE SAYFASI
  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Egitimlerim</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Atanan egitimleriniz — detay icin uzerine tiklayin.</p>
      </div>

      {/* Istatistikler */}
      {egitimler.length > 0 && (
        <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
          <div className="stat-kart"><div className="stat-sayi">{istatistikler.toplam}</div><div className="stat-etiket">Toplam</div></div>
          <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{istatistikler.tamamlanan}</div><div className="stat-etiket">Tamamlandi</div></div>
          <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--mavi)' }}>{istatistikler.devam}</div><div className="stat-etiket">Devam Ediyor</div></div>
          <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--sari)' }}>{istatistikler.sertifika}</div><div className="stat-etiket">Sertifika</div></div>
        </div>
      )}

      {egitimler.length === 0 && (
        <div className="card" style={{ textAlign: 'center', padding: '4rem', color: 'var(--yazi-ikincil)' }}>
          <div style={{ fontSize: '48px', marginBottom: '1rem' }}>📚</div>
          <div style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>Henuz egitim atanmadi</div>
          <p style={{ fontSize: '13px' }}>Size atanan egitimler burada goruntülenecektir.</p>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1rem' }}>
        {egitimler.map(eg => {
          const info = durumInfo(eg.durum, eg.bitis_tarihi);
          const bitisYaklasiyor = eg.bitis_tarihi && eg.durum !== 'tamamlandi' && new Date(eg.bitis_tarihi) > new Date() && (new Date(eg.bitis_tarihi) - new Date()) < 7 * 24 * 60 * 60 * 1000;
          return (
            <div key={eg.id} className="card" style={{ cursor: 'pointer', transition: 'all 0.2s', borderLeft: '4px solid ' + info.renk }}
              onClick={() => { setSeciliEgitim(eg); setSonuc(null); setSertifika(null); }}
              onMouseEnter={e => { e.currentTarget.style.boxShadow = 'var(--shadow-md)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = 'var(--shadow)'; e.currentTarget.style.transform = 'translateY(0)'; }}>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                <h3 style={{ fontSize: '15px', fontWeight: '600', fontFamily: 'DM Sans, sans-serif', flex: 1 }}>{eg.ad}</h3>
                {info.badge}
              </div>

              {eg.aciklama && <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginBottom: '12px', lineHeight: '1.4' }}>{eg.aciklama.slice(0, 80)}{eg.aciklama.length > 80 ? '...' : ''}</p>}

              <div style={{ display: 'flex', gap: '12px', fontSize: '12px', color: 'var(--yazi-ikincil)', marginBottom: '10px', flexWrap: 'wrap' }}>
                <span>📅 {fmt(eg.atama_tarihi)}</span>
                {eg.bitis_tarihi && <span style={{ color: bitisYaklasiyor ? 'var(--kirmizi)' : 'inherit' }}>⏰ {fmt(eg.bitis_tarihi)}</span>}
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  {eg.sertifika_adi && <span style={{ fontSize: '11px', color: 'var(--yesil)', background: 'var(--yesil-acik)', padding: '2px 6px', borderRadius: '4px' }}>🏆 Sertifika</span>}
                  {bitisYaklasiyor && <span style={{ fontSize: '11px', color: 'var(--kirmizi)', background: 'var(--kirmizi-acik)', padding: '2px 6px', borderRadius: '4px' }}>⚠️ Son 7 gun</span>}
                  {eg.platform_link && <span style={{ fontSize: '11px', color: 'var(--mavi)', background: 'var(--mavi-acik)', padding: '2px 6px', borderRadius: '4px' }}>🔗 Platform</span>}
                </div>
                <span style={{ fontSize: '12px', color: 'var(--mavi)' }}>Detay →</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default EgitimlerimPage;
